// Clearly unavailable future areas (no fabricated data).
import type { ReactNode } from "react";
import { EmptyState, PageHeader } from "@/ui/layout";
import { useTitle } from "./page";

export function ComingSoon({ title, description, icon }: { title: string; description: string; icon: ReactNode }) {
  useTitle(title);
  return (
    <div className="grid gap-6">
      <PageHeader title={title} />
      <EmptyState icon={icon} title="Aún no disponible" description={description} />
    </div>
  );
}
